







































# import settings from '@/settings'
import Menus from '@/components/menus'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import params_edit from '@/components/vpe/params_edit'
import params_string from '@/components/vpe/params_string'
import vpe_table from '@/components/vpe/vpe_table'
import abs_table from '@/components/vpe/abs_table'

export default {
    name: 'company_variable_payroll'

    components: { Menus, params_edit, params_string, vpe_table, abs_table }

    props:
        date_prop:
            required: false

    watch:
        date_prop: (new_value, old_value)->
            # console.log "WATCH DATE PROP", new_value, old_value
            if new_value != old_value
                if new_value in ['', null, undefined]
                    @date = t.python_date_formatter(new Date()).split(' ')[0]
                else
                    @date = new_value

    data: ()->
        tabs_active_name: 'first'
        vp_custom_set: []
        params: {}
        update: false
        date: ''

    methods:
        has_access_right: t.has_access_right

        change_vpc: ()->
            # console.log "EMIT IN PARENT"
            @get_vpc_set()
            @get_company_info()
            return

        new_params: (params)->
            @params = params
            return

        update_params: ()->
            @update = !@update
            return

        get_company_info: ()->
            self = @
            q.run('get_company', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_variable_payroll: get_company: then" ,e.message)
                else
                    # console.log "GET COMPANY : ", resp.body.data.company.has_accounting_software
                    # console.log "GET COMPANY : ", resp.body.data.company.has_vpc_to_bind
                    self.$store.commit("set_has_vpc_to_bind", resp.body.data.company.has_vpc_to_bind)
                    self.$store.commit("set_has_accounting_software", resp.body.data.company.has_accounting_software)
            .catch (resp)->
                n.catch_error(resp, "company_variable_payroll: get_company()")

        get_vpc_set: ()->
            self = @
            q.run('get_vpc_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_variable_payroll: get_vpc_set: then", e.message)
                else
                    # console.log "GET_VPC_SET : ", resp.body.data.variable_payroll_custom_set
                    if resp.body.data.variable_payroll_custom_set != null
                        self.vp_custom_set = resp.body.data.variable_payroll_custom_set
            .catch (resp)->
                n.catch_error(resp, "company_variable_payroll: get_vpc_set()")

    beforeMount: ()->
        # console.log "beforeMount company_variable_payroll ", @date_prop, @date
        if @date_prop not in [undefined, null, '']
            @date = @date_prop
        if @date_prop in [undefined, null, ''] and @date == ''
            @date = t.python_date_formatter(new Date()).split(' ')[0]
        @get_vpc_set()
        @get_company_info()
}
